import ChildContentModal from 'components/GlobalModals/ChildContentModal/ChildContentModal';
import { withChildContentModalProps } from 'viewModel/globalModals/childContentModal/withChildContentModalProps';

export default withChildContentModalProps(ChildContentModal);
